import APP_CONFIG, { LOCAL_DATA } from '@/APP_CONFIG';
import { useUserStore } from '@/pinia/user';
import { IsPC } from '@/utils/is';
// export enum JS_LIBS {}
// VCONSOLE = 'https://cdn.bootcdn.net/ajax/libs/vConsole/3.9.1/vconsole.min.js',

import VConsole from 'vconsole';

export function useEnv() {
  // 是否开启 vconsole 调试
  if (APP_CONFIG.DEBUG.VCONSOLE) {
    console.warn('[VConsole] 已开启！');
  }
  if (APP_CONFIG.DEBUG.VCONSOLE && !IsPC()) {
    new VConsole();
  }

  // 本地环境设置 'development'
  if (APP_CONFIG.ENV == 'development') {
    const user = useUserStore();
    user.setUserOpenId(LOCAL_DATA.openid);
    user.setUserToken(LOCAL_DATA.token);
  }
}

export function useJs(url) {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script') as HTMLScriptElement;
    script.type = 'text/javascript';
    script.onload = function () {
      resolve();
    };
    script.onerror = function () {
      reject();
    };
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  });
}

export function useVConsole() {
  return { VConsole };
}
